/* eslint-disable @next/next/no-img-element */
import * as Collapsible from '@radix-ui/react-collapsible'
import classNames from 'classnames'
import { FunctionComponent, ReactNode, useState } from 'react'
import styles from './SimpleCollapsible.module.css'
import TXT from '@/messages'

type Props = {
  header: ReactNode
  children: ReactNode
  defaultOpen?: boolean
  icon?: ReactNode
}

const SimpleCollapsible: FunctionComponent<Props> = ({
  header,
  children,
  defaultOpen = false,
  icon,
}: Props) => {
  const [open, setOpen] = useState(defaultOpen as boolean)

  return (
    <Collapsible.Root open={open} onOpenChange={setOpen}>
      <Collapsible.Trigger className={styles.Header} data-testid="collapsible-trigger">
        <div className={styles.Title}>
          {icon}
          {header}
        </div>
        <img
          src="/static/svg/angle-down.svg"
          className={classNames(
            styles.Svg,
            { [styles.Open]: open },
          )}
          alt={TXT.a11y.toggleCollapsed}
        />
      </Collapsible.Trigger>
      <Collapsible.Content className={styles.Content} data-testid="collapsible-info-content">
        {children}
      </Collapsible.Content>
    </Collapsible.Root>
  )
}
export default SimpleCollapsible
